import { FormCard, FormItem, TextArea } from '@lmc/ui-kit'
import { RichTextFormField } from 'components/generic/richText/RichTextFormField'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

interface PersonalNotesFormCardProps {
  disabled?: boolean
  richTextEnabled?: boolean
}

export const PersonalNotesFormCard = ({
  disabled = false,
  richTextEnabled = false
}: PersonalNotesFormCardProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  return (
    <FormCard
      title={t(supConstants.PERSONAL_NOTES)}
      subtitle={t(supConstants.PERSONAL_NOTES_DESC)}
    >
      <FormItem name="summary">
        {richTextEnabled ? (
          <RichTextFormField disabled={disabled} />
        ) : (
          <TextArea
            autoSize={{
              minRows: 3
            }}
          />
        )}
      </FormItem>
    </FormCard>
  )
}
